__turbopack_context__.v({
  "root": "WQWOjG_root",
});
